import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ element: Component, requiredRole,roles, ...rest }) => {
  const token = localStorage.getItem('token');
  let isAuthenticated = false;
  let userRole = '';

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 > Date.now()) {
        isAuthenticated = true;
        userRole = decodedToken.role; // Estrai il ruolo dal token
      }
    } catch (error) {
      console.error('Token non valido', error);
    }
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Se il ruolo non corrisponde, reindirizza l'utente
  if (requiredRole && userRole !== roles) {
    return <Navigate to="/home" />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;